import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { ItemLabel } from 'app/providers/storage-api/object-label.service';

@Component({
  selector: 'app-item-label',
  imports: [AppSharedModule],
  templateUrl: './item-label.component.html',
  styleUrl: './item-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemLabelComponent {
  @Input() itemType: string;
  @Input() label: ItemLabel;
  @Input() size: 'normal' | 'large' = 'normal';

  @HostBinding('class') get clazz() {
    return `item-label--size-${this.size}`;
  }
}
